const Reports = (props) => {
  const reportURL = process.env.REACT_APP_AMPLIFY_REPORTING;
  return window.location.replace(`${reportURL}/storeId:${props.store}`);
};

export default Reports;
